import {Component} from '@angular/core';
import {
	EntitySelectComponent,
	BaseModel,
	BaseModelInterface,
} from '@app/abstracts';
import {ErrorService} from '@app/services';
import {RouteSearchParams} from '../route-search-params';
import {RouteService} from '../route.service';
import {Route} from '../route';
import { QuickFormService } from '../../../plugins/quick-form';
@Component({
  selector: 'hpf-route-select',
  templateUrl: '../../../abstracts/entity-select/entity-select.component.html'
})
export class RouteSelectComponent extends EntitySelectComponent< Route> {
  protected modelName = 'route';
  /**
   * Constructor
   * @param {RouteService} routeService
   * @param {ErrorService} errorService
   */
  constructor(private routeService: RouteService,
              protected errorService: ErrorService,
              protected quickFormService: QuickFormService) {
    super(errorService, quickFormService);
  }
  ngOnInit() {
		super.ngOnInit();
    // Refresh model in case of creation by quick form
		this.subscriptions.push(
			this.quickFormService.refresh.subscribe(
				(model: BaseModel<BaseModelInterface, {}>) => {
					if(!(model instanceof Route)) return;
          if(this.multiple) {
            if (!this.model) this.model = [];
            (<Route[]>this.model).push(<Route>model);
          } else {
            this.model = <Route>model;
          }
          this.refresh();
				}
			)
		);
	}
  /** @inheritDoc */
  protected async getList(): Promise< Route[]> {
      const params = new RouteSearchParams({
          _limit: this.resultsLimit,
          _page: this.currentPage
      });
      if (this.filterEnabled && this.filterValue) {
        params.props._text = this.filterValue;
      }
      return (await this.routeService.list(params.toObject())).items;
  }
  /** @inheritDoc */
  protected async getOne(id: string): Promise< Route> {
      return await this.routeService.get(id);
  }
}
